<sw-page class="topdata-llm-connect-llm-model-list-page">
    <template #search-bar>
        <sw-search-bar
            initial-search-type="tdlc_llm_model"
            :initial-search="term"
            @search="onSearch"
        />
    </template>

    <template #smart-bar-header>
        <h2>{{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <mt-select
            :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.filterProvider')"
            :options="providerOptions"
            :model-value="providerFilter"
            @update:model-value="onChangeProviderFilter"
            :placeholder="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.filterAllProviders')"
            size="medium"
            class="topdata-llm-connect-llm-model__filter"
        ></mt-select>

        <sw-button variant="primary" :router-link="{ name: 'topdata.llm.connect.llm.model.create' }">
            {{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.buttonAdd') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-llm-connect-llm-model"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="true"
            :allow-delete="true"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            detail-route="topdata.llm.connect.llm.model.detail"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-model="{ item }">
                <span class="topdata-llm-connect-llm-model__model-identifier">
                    {{ fullModelIdentifier(item) }}
                </span>
                <button
                    class="topdata-llm-connect-llm-model__copy"
                    :title="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.copyModelIdentifier')"
                    @click="onCopyModelIdentifier(item)"
                >
                    <mt-icon name="regular-duplicate" size="14px"></mt-icon>
                </button>
            </template>

            <template #column-active="{ item }">
                <sw-label v-if="item.active" variant="success" size="medium">
                    {{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.activeYes') }}
                </sw-label>
                <sw-label v-else variant="danger" size="medium">
                    {{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.activeNo') }}
                </sw-label>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago :date="item.createdAt" :date-time-format="{ month: '2-digit', day: '2-digit' }" />
            </template>

            <template #column-isFavorite="{ item }">
                <button
                    class="topdata-llm-connect-llm-model__favorite"
                    :title="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.favoriteToggle')"
                    @click="onToggleFavorite(item)"
                >
                    <sw-icon :name="item.isFavorite ? 'solid-star' : 'regular-star'"></sw-icon>
                </button>
            </template>
        </sw-entity-listing>
    </template>
</sw-page>
